import { AxiosRequestHeaders } from 'axios';
import { axios } from '../interceptors';
import { CustomerDetail } from '../models/customer';
import { UtilService } from './util-service';

class CustomerService {
  private static baseUrl = '/customer';

  public static async getCustomerDetail(commercialRateEnabled: boolean | undefined) {
    const headers = UtilService.addFeatureHeader({}, commercialRateEnabled, 'COMMERCIAL_RATES') as AxiosRequestHeaders | undefined;
    const response = await axios.get<CustomerDetail>(this.baseUrl, { headers });
    return response.data;
  }
}

export { CustomerService };
